import BaseAPI from "./base/base-api";

class EmployeeAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "Employee";
}

export default new EmployeeAPI();
